import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

function CaseMeta({
  index,
  organisation,
  period,
}: {
  index: number;
  organisation: string;
  period: string;
}) {
  return (
    <div className="case__meta">
      <span className="case__number" dir="ltr">
        {String(index).padStart(2, '0')}
      </span>
      <span className="case__rule" />
      <span className="case__where">
        {organisation} · <bdi>{period}</bdi>
      </span>
    </div>
  );
}

export function Work() {
  const { t } = useTranslation(['work']);
  const { leadCase, supportingCases } = profile;

  return (
    <section id="work" className="work">
      <div className="section-head">
        <h2 className="section-title">
          {t('work:titleLine1')}
          <br />
          {t('work:titleLine2')}
        </h2>
        <p className="section-lede">{t('work:lede')}</p>
      </div>

      <div className="work__list">
        <article className="case case--lead">
          <img
            className="case__image"
            src={leadCase.image.src}
            srcSet={leadCase.image.srcSet}
            sizes="(min-width: 900px) 40vw, 100vw"
            alt=""
            width={1200}
            height={1200}
            loading="lazy"
          />
          <div className="case__body">
            <CaseMeta index={1} organisation={leadCase.organisation} period={leadCase.period} />
            <h3 className="case__title">{t(`work:cases.${leadCase.id}.title`)}</h3>
            <p className="case__text">{t(`work:cases.${leadCase.id}.body`)}</p>
            <div className="chips">
              {leadCase.stack.map((item) => (
                <span key={item} className="chip" dir="ltr">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </article>

        <div className="work__pair">
          {supportingCases.map((caseStudy, index) => (
            <article key={caseStudy.id} className="case case--plain">
              <div className="case__body">
                <CaseMeta
                  index={index + 2}
                  organisation={caseStudy.organisation}
                  period={caseStudy.period}
                />
                <h3 className="case__title">{t(`work:cases.${caseStudy.id}.title`)}</h3>
                <p className="case__text">{t(`work:cases.${caseStudy.id}.body`)}</p>
                <div className="case__outcome">{t(`work:cases.${caseStudy.id}.outcome`)}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
